import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UiAuthService } from './ui-auth.service';

@Injectable({ providedIn: 'root' })
export class V3RedirectGuard implements CanActivate {
  constructor(private uiAuthService: UiAuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.uiAuthService.isV3) {
      this.router.navigate(['/savvy-pet']);
      return false;
    }
    return true;
  }
}
